import * as React from 'react'

import { inject, observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import StatusBadge from '~/client/src/shared/components/StatusBadge/StatusBadge'
import WorkflowTypeIcon from '~/client/src/shared/components/WorkflowTypeIcon/WorkflowTypeIcon'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import CalendarEvent from '~/client/src/shared/models/CalendarEvent'
import Workflow from '~/client/src/shared/models/Workflow'
import CompaniesStore from '~/client/src/shared/stores/domain/Companies.store'
import LocationAttributesStore from '~/client/src/shared/stores/domain/LocationAttributes.store'
import WorkflowTypesStore from '~/client/src/shared/stores/domain/WorkflowTypes.store'
import { INTERPUNCT } from '~/client/src/shared/utils/usefulStrings'

interface IProps {
  event: CalendarEvent
  showPermitType?: boolean
  iconClassName?: string

  setIgnoreTooltip?(isIgnored: boolean): void

  workflowTypesStore?: WorkflowTypesStore
  companiesStore?: CompaniesStore
  locationAttributesStore?: LocationAttributesStore
}

@inject('workflowTypesStore', 'companiesStore', 'locationAttributesStore')
@observer
export default class FormMultiDayEventLabel extends React.Component<IProps> {
  public render() {
    const { event } = this.props

    if (event.isNew) {
      return (
        <div className="text-bold no-grow">
          {Localization.translator.newForm}
        </div>
      )
    }

    const { locationAttributesStore, showPermitType, iconClassName } =
      this.props

    const locationName = locationAttributesStore.getLocationBySiteLocationObj(
      this.form.locations[0],
    )?.name

    return (
      <div className="row">
        <WorkflowTypeIcon
          iconName={this.iconNameOfFormType}
          className={classList({
            'row no-grow mr4': true,
            [iconClassName]: !!iconClassName,
          })}
        />
        {this.companyName && (
          <>
            <span className="text-bold no-grow">{this.companyName}</span>
            {this.interpunct}
          </>
        )}
        <span className="text light no-grow">{event.label}</span>
        {this.interpunct}
        {showPermitType && this.nameOfFormType && (
          <>
            <span className="text light bold uppercase lp015 no-grow">
              {this.nameOfFormType}
            </span>
            {this.interpunct}
          </>
        )}
        <StatusBadge
          className="tw:!flex-none"
          status={this.form.status}
          workflowStepLevel={this.form.workflowStepLevel}
          isLate={this.form.isLate}
          compact
        />
        {locationName && (
          <>
            {this.interpunct}
            {locationName}
          </>
        )}
      </div>
    )
  }

  private get interpunct(): JSX.Element {
    return <span className="px4 no-grow">{INTERPUNCT}</span>
  }

  private get form(): Workflow {
    return this.props.event.data
  }

  private get iconNameOfFormType(): string {
    return this.form.getIconNameOfPermitType(this.props.workflowTypesStore)
  }

  private get nameOfFormType(): string {
    return this.form.getNameOfPermitType(this.props.workflowTypesStore)
  }

  private get companyName(): string {
    const [companyId] = this.form.companyIds

    return this.props.companiesStore.getCompanyNameById(companyId, null)
  }

  private setIgnoreTooltip = () => {
    this.props.setIgnoreTooltip?.(true)
  }

  private setToNotIgnoreTooltip = () => {
    this.props.setIgnoreTooltip?.(false)
  }
}
